<template>
    <div class="padding-container">
        <div class="box mt-4 m-mt-0">
            <div class="mb-3">
                <h3 class="fw-bold capitalize">Daftar Follow Up CRO</h3>
            </div>
            <div class="d-flex align-items-center no-flex mt-4">
                <div class="me-3 m-mx-0">
                    <div class="position-relative">
                        <input
                            type="text"
                            class="form-control form-control-lg pl-search w-search"
                            placeholder="Cari Nama Customer"
                            v-model="keySearch"
                            @input="changePage()"
                        />
                        <span class="search-icon left">
                            <i class="fa fa-search"></i>
                        </span>
                    </div>
                </div>
                <div class="me-auto m-mt-1">
                    <button
                        class="btn btn-outline-black btn-filter px-4"
                        @click="isFilter = !isFilter"
                    >
                        <img
                            src="../../assets/dashboard/filter.png"
                            class="me-1"
                            width="18"
                            alt=""
                        />
                        Filter
                    </button>
                </div>
            </div>
            <div class="box mt-3 position-relative" v-if="isFilter">
                <div class="row">
                    <div class="col-md-6 mb-2">
                        <multiselect
                            v-model="service"
                            :options="services"
                            label="name"
                            track-by="id"
                            placeholder="Select Service"
                            class="multi-form-custom"
                        >
                        </multiselect>
                    </div>
                    <div class="col-md-6 mb-2">
                        <multiselect
                            v-model="type_filter"
                            :options="types"
                            label="label"
                            track-by="type"
                            placeholder="Select Type"
                            class="multi-form-custom"
                        >
                        </multiselect>
                    </div>
                    <div class="col-md-2">
                        <button
                            class="btn btn-outline-black px-5 w-100"
                            :disabled="range == ''"
                            @click="clearFilter()"
                        >
                            Clear
                        </button>
                    </div>
                    <div class="col-md-2">
                        <button
                            class="btn btn-green px-5 w-100"
                            :disabled="service == null && type_filter == null"
                            @click="filter()"
                        >
                            Filter
                        </button>
                    </div>
                </div>
            </div>
            <div class="mt-4" v-if="is_load_data">
                <ListLoader />
            </div>
            <div v-else>
                <div class="table-responsive-custom">
                    <table class="table table-bordered mt-4">
                        <thead class="table-light">
                            <tr>
                                <th class="text-center" scope="col">No</th>
                                <th class="text-center" scope="col">
                                    Tgl. LastOrder
                                </th>
                                <th class="text-center" scope="col">
                                    Tgl. FollowUp
                                </th>
                                <th class="text-center" scope="col">
                                    Nama Customer
                                </th>
                                <th
                                    class="text-center"
                                    scope="col"
                                    v-show="isRole(rolesAssign)"
                                >
                                    AssignedCRO
                                </th>
                                <th class="text-center" scope="col">Layanan</th>
                                <th class="text-center" scope="col">
                                    Tipe Data
                                </th>
                                <th class="text-center" scope="col">
                                    Kategori
                                </th>
                                <th class="text-center" scope="col">
                                    Prediction
                                </th>
                                <th class="text-center" scope="col">Result</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in data" :key="index">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td class="text-center">
                                    <template v-if="item.last_order">
                                        {{
                                            moment(item.last_order).format(
                                                "DD/MM/YYYY"
                                            )
                                        }}
                                    </template>
                                    <template v-else> - </template>
                                </td>
                                <td class="text-center">
                                    {{
                                        moment(item.last_follow_up).format(
                                            "DD/MM/YYYY"
                                        )
                                    }}
                                </td>
                                <td class="">
                                    <router-link
                                        class="text-link"
                                        :to="{
                                            name: 'crm-follow-up-cro-detail',
                                            params: {
                                                id: item.latest_prospect,
                                            },
                                        }"
                                    >
                                        {{ item.name }}
                                    </router-link>
                                </td>
                                <td
                                    class="capitalize"
                                    v-show="isRole(rolesAssign)"
                                >
                                    {{
                                        item.assigned_to
                                            ? item.assigned_to
                                            : "-"
                                    }}
                                </td>
                                <td class="capitalize">
                                    {{
                                        (item.service || "")
                                            .split("-")
                                            .join(" ")
                                    }}
                                </td>
                                <td class="capitalize text-center">
                                    <div
                                        class="tag radius w-100 size-12"
                                        v-bind:class="{
                                            'green-cro':
                                                item.type == 'prospect',
                                            'blue-cro': item.type == 'leads',
                                        }"
                                    >
                                        {{ item.type }}
                                    </div>
                                </td>
                                <td class="capitalize text-center">
                                    <div
                                        class="tag radius w-100 size-12"
                                        v-bind:class="{
                                            'green-cro':
                                                item.category == 'New Order',
                                            'blue-cro':
                                                item.category == 'Repeat Order',
                                        }"
                                    >
                                        {{ item.category }}
                                    </div>
                                </td>
                                <td>
                                    <a
                                        :href="
                                            '/crm/prospect/prediction/' +
                                            item.latest_prospect
                                        "
                                        class="prediction-color"
                                    >
                                        <u>
                                            <template
                                                v-if="item.prediction != null"
                                            >
                                                {{
                                                    currencyFormat(
                                                        item.prediction
                                                    )
                                                }}
                                            </template>
                                            <template v-else>
                                                Not Filled Yet
                                            </template>
                                            <img
                                                src="../../assets/book-icon.png"
                                                alt=""
                                                class="ms-2"
                                                width="19"
                                            />
                                        </u>
                                    </a>
                                </td>
                                <td class="text-center">
                                    <div class="dropdown">
                                        <a
                                            href="javascript:void(0)"
                                            id="dropdownMenuButton1"
                                            data-bs-toggle="dropdown"
                                        >
                                            <img
                                                src="../../assets/dashboard/ellipsis-green.png"
                                                width="22"
                                                alt=""
                                            />
                                        </a>
                                        <ul
                                            class="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton1"
                                        >
                                            <li>
                                                <router-link
                                                    class="dropdown-item"
                                                    :to="{
                                                        name: 'crm-prospect-deal',
                                                        params: {
                                                            id: item.latest_prospect,
                                                        },
                                                    }"
                                                    >Deal</router-link
                                                >
                                            </li>
                                            <li>
                                                <router-link
                                                    class="dropdown-item"
                                                    :to="{
                                                        name: 'crm-prospect-lost',
                                                        params: {
                                                            id: item.latest_prospect,
                                                            type: 'lost',
                                                        },
                                                    }"
                                                    >Lost</router-link
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="data.length == 0" class="text-center mt-section">
                    <img src="../../assets/no-data.png" width="100" alt="" />
                    <h4 class="mb-0 fw-bold mt-4 mb-4 text-gray">
                        Data Kosong
                    </h4>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div class="ms-auto">
                    <div class="d-flex align-items-center">
                        <div class="me-3">
                            <select
                                class="form-control form-select w-select"
                                v-model="limit"
                                @change="getData()"
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <b-pagination-nav
                            v-if="data.length > 0"
                            v-model="currentPage"
                            :number-of-pages="totalPage"
                            base-url="#"
                            first-number
                            align="right"
                            @input="changePage"
                        ></b-pagination-nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Api from "../../api/Api";
import ListLoader from "../../components/ListLoader.vue";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
    components: {
        ListLoader,
        Multiselect,
    },
    props: {
        items: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            moment: moment,
            data: [],
            keySearch: "",
            is_load_data: false,
            currentPage: 0,
            totalPage: 0,
            limit: 5,
            isFilter: false,
            service: null,
            services: [
                {
                    name: "Kirim Barang",
                    id: "kirim-barang",
                },
                {
                    name: "Kirim Motor",
                    id: "kirim-motor",
                },
                {
                    name: "Via Udara",
                    id: "via-udara",
                },
                {
                    name: "Sewa Truk",
                    id: "sewa-truck",
                },
            ],
            type_filter: null,
            types: [
                {
                    type: "prospect",
                    label: "Prospect",
                },
                {
                    type: "leads",
                    label: "Leads",
                },
            ],
            roles: [],
            rolesAssign: ["admin-crm", "crm-manager"],
        };
    },
    created() {
        this.getData();
        this.getUserLogin();
    },
    methods: {
        getUserLogin() {
            Api.get(`${process.env.VUE_APP_SERVICE_URL}/account/user/me`, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((res) => {
                    this.roles = res.data.data.roles;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        isRole(value) {
            let result = value.some((el) => this.roles.includes(el));
            return result;
        },
        currencyFormat(num) {
            return (
                "Rp" +
                parseInt(num)
                    .toFixed(0)
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
            );
        },
        changePage() {
            this.getData();
        },
        getData() {
            this.is_load_data = true;
            var params = {
                page:
                    this.currentPage == 0 || this.currentPage == null
                        ? 0
                        : this.currentPage - 1,
                limit: this.limit,
                search: this.keySearch,
                start_date: "",
                end_date: "",
                type: this.type_filter?.type,
                service: this.service?.id,
            };
            if (
                this.roles.includes("admin-crm") ||
                this.roles.includes("crm-manager")
            ) {
                params.view = "admin";
            }
            Api.get(
                `${process.env.VUE_APP_SERVICE_URL}/crm/customer/cro/leads`,
                {
                    params: params,
                    headers: {
                        Authorization:
                            "Bearer " + localStorage.getItem("token"),
                    },
                }
            )
                .then((res) => {
                    console.log(res, "dres");
                    this.data = res.data.data.list_data;
                    this.totalPage = res.data.data.total_page;
                    this.is_load_data = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.is_load_data = false;
                });
        },
        clearFilter() {
            this.service = null;
            this.type_filter = null;
            this.getData();
        },
        filter() {
            this.getData();
        },
    },
};
</script>
<style lang="scss" scoped>
th {
    border-color: #e8e8e9;
    padding: 10px !important;
}
tr {
    border-color: #e8e8e9;
    padding: 10px !important;
}
td {
    padding: 10px !important;
}
.table-light {
    background-color: #f6faff !important;
    --bs-table-border-color: #f6faff !important;
    --bs-table-bg: #f6faff !important;
}
</style>
